import { Controller } from "@hotwired/stimulus"
import { Modal, Popover, Tooltip } from "bootstrap"

export default class extends Controller {
  connect() {
    this.boundClick = this.handleClick.bind(this)
    this.element.addEventListener("click", this.boundClick)
    this.pendingConfirmationForm = null
    this.initializePlugins()
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundClick)
    this.tooltips?.forEach((tooltip) => tooltip.dispose())
    this.popovers?.forEach((popover) => popover.dispose())
    this.modals?.forEach((modal) => modal.removeEventListener("show.bs.modal", this.boundModalShow))
  }

  initializePlugins() {
    this.tooltips = Array.from(this.element.querySelectorAll('[data-bs-toggle="tooltip"]'))
      .map((element) => Tooltip.getOrCreateInstance(element, { container: document.body }))
    this.popovers = Array.from(this.element.querySelectorAll('[data-bs-toggle="popover"]'))
      .map((element) => Popover.getOrCreateInstance(element, { html: true, trigger: "hover focus", container: document.body }))
    this.boundModalShow = (event) => event.relatedTarget?.blur()
    this.modals = Array.from(this.element.querySelectorAll(".modal"))
    this.modals.forEach((modal) => modal.addEventListener("show.bs.modal", this.boundModalShow))
    this.element.querySelectorAll("input[type=checkbox].toggle")
      .forEach((checkbox) => checkbox.classList.add("wbd-native-toggle"))
  }

  handleClick(event) {
    const languageToggle = event.target.closest("#toggle-english, #toggle-spanish")
    if (languageToggle) {
      event.preventDefault()
      document.body.classList.toggle("lang-en", languageToggle.id === "toggle-english")
      document.body.classList.toggle("lang-es", languageToggle.id === "toggle-spanish")
      return
    }

    if (event.target.closest("#print-page")) {
      event.preventDefault()
      window.print()
      return
    }

    const tooltip = event.target.closest('[data-bs-toggle="tooltip"]')
    if (tooltip) tooltip.blur()

    const confirmation = event.target.closest("[data-confirm]")
    if (confirmation) this.confirmSubmit(event, confirmation)
  }

  confirmSubmit(event, trigger) {
    event.preventDefault()
    let fields = {}
    try { fields = JSON.parse(trigger.dataset.fields || "{}") } catch (_) { fields = {} }
    Object.entries(fields).forEach(([key, value]) => {
      const field = document.querySelector(`#confirm-submit-dialog .${CSS.escape(key)}`)
      if (field) field.textContent = value
    })

    const dialog = document.querySelector("#confirm-submit-dialog")
    if (!dialog) return
    const modal = Modal.getOrCreateInstance(dialog)
    this.pendingConfirmationForm = trigger.matches("form") ? trigger : trigger.closest("form")
    const submitButton = dialog.querySelector("#confirm-submit")
    if (this.confirmHandler) submitButton.removeEventListener("click", this.confirmHandler)
    this.confirmHandler = (confirmEvent) => {
      confirmEvent.preventDefault()
      const form = this.pendingConfirmationForm
      this.pendingConfirmationForm = null
      modal.hide()

      // Delay navigation until both the browser and WebDriver have completed
      // the confirmation click. This also avoids duplicate submissions.
      window.setTimeout(() => form?.submit(), 150)
    }
    submitButton.addEventListener("click", this.confirmHandler, { once: true })
    modal.show()
  }

}
